import { createSlice } from "@reduxjs/toolkit";
import { fetchRequest } from "../services/api";
import { getAvailableHardwares, getDeleteHardwareRequest } from "../services/hardware-requests";
import { uiActions } from "./ui-slice";

const hardwaresSlice = createSlice({
  name: "hardwares",
  initialState: { list: [], selected: undefined },
  reducers: {
    set(state, action) {
      state.list = action.payload;
    },
    setSelected(state, action) {
      state.selected = state.list.find((h) => h.id === action.payload);
    },
    del(state, action) {
      state.list = state.list.filter((h) => h.id !== action.payload);
      state.selected = null;
    },
    bind(state, action) {
      const hardware = state.list.find(
        (h) => h.id === action.payload.bindResult.hardware.id
      );
      if (hardware) {
        hardware.isAssigned = true;
        return;
      } 
      state.list.push(action.payload.bindResult.hardware);      
    },
    unbind(state, action) {
      const hardware = state.list.find(
        (h) => h.identifier === action.payload
      );
      if (hardware) {
        hardware.isAssigned = false;        
      }     
    }
  },
});

export const hardwaresActions = hardwaresSlice.actions;

export const fetchHardwareData = (licenseId) => {
  return async (dispatch) => {
    const fetchHardwares = async (licenseId) => {
      return await fetchRequest(getAvailableHardwares(licenseId));
    };
    try {
      const hardwares = await fetchHardwares(licenseId);
      dispatch(hardwaresActions.set(hardwares));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const deleteHardware = (hardware) => {
  return async (dispatch) => {
    try {
      await fetchRequest(getDeleteHardwareRequest(hardware.id));
      dispatch(hardwaresActions.del(hardware.id));      
      dispatch(
        uiActions.enqueNotification({
          message: "Deleted",
          variant: "success",
        })
      );
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export default hardwaresSlice.reducer;
